/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AbstractControl, ValidationErrors } from "@angular/forms";

import moment from "moment";
import peselToBirthDateUtil from "../utils/pesel-to-birth-date.util";

const checkSum = (digits: number[]) => {
  const digit11 = digits[10];
  digits.pop();

  const times = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const reducer = (accumulator: number, currentValue: number, index: number) =>
    accumulator + currentValue * times[index];

  let sum = digits.reduce(reducer);

  sum %= 10;
  sum = 10 - sum;
  sum %= 10;

  return sum === digit11;
};

const peselToDigits = (value: string): number[] =>
  value.split("").map((item) => parseInt(item, 10));

export const validatePesel = (value: string): boolean => {
  const digits = peselToDigits(value);

  if (digits.length !== 11 && digits.every((item) => !isNaN(item))) {
    return false;
  }

  return checkSum(digits);
};

export const validateLegalAgePesel = (value: string): boolean => {
  const birthdate = peselToBirthDateUtil(value);

  if (!birthdate) {
    return false;
  }

  const age = moment(new Date()).diff(new Date(birthdate), "years");

  return age >= 18;
};

export const validateOver80AgePesel = (value: string): boolean => {
  const birthdate = peselToBirthDateUtil(value);

  if (!birthdate) {
    return false;
  }

  const age = moment(new Date()).diff(new Date(birthdate), "years");

  return age <= 80;
};

export const PeselOver80Validator = (
  formControl: AbstractControl,
): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const over80AgePesel = !validateOver80AgePesel(value);

  return {
    ...(over80AgePesel && { over80AgePesel }),
  };
};

export const PeselValidator = (
  formControl: AbstractControl,
): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const pesel = !validatePesel(value);
  const underLegalAgePesel = !validateLegalAgePesel(value);
  // const over80AgePesel = !validateUnder80AgePesel(value);

  return {
    ...(pesel && { pesel }),
    ...(underLegalAgePesel && { underLegalAgePesel }),
    // ...(over80AgePesel && { over80AgePesel }),
  };
};

